module.exports = __webpack_public_path__ + "static/media/micky.88e9a90b.jpeg";